import "../../types/customizer-global";
import { CURRENT_COLOR_SELECTOR, OUTLINE_SWATCH_SELECTOR } from "../constants/selectors";
import disableInput from "../dom/disableInput";
import enableInput from "../dom/enableInput";
import hideOutline from "../dom/hideOutline";
import resetInputValue from "../dom/resetInputValue";
import resetOutline from "../dom/resetOutline";
import selectSingleElement from "../dom/selectSingleElement";
import { showOrHideElements } from "../dom/showOrHideElements";
import {
  BOTTOM_LETTERS_INPUT,
  BOTTOM_LETTERS_WRAPPER_SELECTOR,
  CANVAS_ELEMENTS_WRAPPER,
  OUTLINE_TEXT,
  SCRIPT_TEXT_INPUT,
  SECONDARY_LETTERS,
  SECONDARY_LETTERS_WRAPPER_SELECTOR,
  THREED_LIFT_TEN,
} from "./_selectors";
import generateCanvas from "./generateCanvas";

export type FontClickedProps = {
  font?: string;
  threeDGridColumn?: string;
  shouldResetOutline?: boolean;
  hasCurrentColor?: boolean;
  showOutline?: boolean;
  disableSecondaryLetters?: boolean;
  disableBottomLetters?: boolean;
  inputElementsToReset?: (HTMLInputElement | null)[];
  elementsToShowOrHide?: {
    elements: (HTMLElement | null)[] | HTMLElement | NodeListOf<HTMLElement> | null;
    show: boolean;
    displayValue?: string;
    important?: boolean;
  }[];
};

export function fontClicked({
  font,
  threeDGridColumn,
  shouldResetOutline = false,
  showOutline = true,
  hasCurrentColor = false,
  disableBottomLetters = false,
  disableSecondaryLetters = false,
  inputElementsToReset = [],
  elementsToShowOrHide = [],
}: FontClickedProps) {
  console.log("font clicked", font);
  
  // Store the current font in global state
  if (font) {
    window.currentCustomizerFont = font;
  }
  // Get the elements
  // const microCheckbox = selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX);
  const threeD = selectSingleElement<HTMLElement>(THREED_LIFT_TEN);
  const bottomLettersInput =
    selectSingleElement<HTMLInputElement>(BOTTOM_LETTERS_INPUT);
  const bottomLettersWrapper = selectSingleElement<HTMLDivElement>(
    BOTTOM_LETTERS_WRAPPER_SELECTOR,
  );
  const secondaryLettersInput =
    selectSingleElement<HTMLInputElement>(SECONDARY_LETTERS);
  const secondaryLettersWrapper = selectSingleElement<HTMLDivElement>(
    SECONDARY_LETTERS_WRAPPER_SELECTOR,
  );
  const canvasWrapper = selectSingleElement<HTMLDivElement>(CANVAS_ELEMENTS_WRAPPER);
  const scriptTextInput = selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT);
  if (font && canvasWrapper !== null) {
    if (font === "Bottomsup") {
      console.log("flip canvas wrapper");
      canvasWrapper.style.transform = "scale(-1, 1)";
      if (scriptTextInput) {
        scriptTextInput.style.direction = "rtl";
        scriptTextInput.style.unicodeBidi = "bidi-override";
      }
    } else {
      console.log("reset canvas wrapper");
      canvasWrapper.style.transform = "scale(1, 1)";
      if (scriptTextInput) {
        scriptTextInput.style.direction = "ltr";
        scriptTextInput.style.unicodeBidi = "normal";
      }
    }
  }
  // Disable or enable the input elements
  if (disableBottomLetters) {
    disableInput(bottomLettersInput, bottomLettersWrapper);
  } else {
    enableInput(bottomLettersInput, bottomLettersWrapper);
  }

  if (disableSecondaryLetters) {
    disableInput(secondaryLettersInput, secondaryLettersWrapper);
  } else {
    enableInput(secondaryLettersInput, secondaryLettersWrapper);
  }

  // reset the input values
  for (const inputElement of inputElementsToReset) {
    if (inputElement !== null) resetInputValue(inputElement);
  }

  if (elementsToShowOrHide) {
    for (const { elements, show, displayValue, important } of elementsToShowOrHide) {
      showOrHideElements({
        elements,
        show,
        displayValue,
        important,
      });
    }
  }
  if (shouldResetOutline) resetOutline();
  if (!showOutline) hideOutline();

  // Only regenerate outline canvas if there's text AND an outline color selected
  if (font) {
    const outlineInput = selectSingleElement<HTMLInputElement>(OUTLINE_TEXT, true);
    const currentOutlineText = outlineInput?.value || "";
    
    // Check if there's an active outline color swatch selected (suppress error as it's expected to not exist sometimes)
    const activeOutlineSwatch = selectSingleElement(`${OUTLINE_SWATCH_SELECTOR}.selected`, true);
    const currentOutlineColor = activeOutlineSwatch ? (activeOutlineSwatch as HTMLElement).dataset.color || "transparent" : "transparent";
    
    // Only generate canvas if there's actual text and a color selected
    if (currentOutlineText && activeOutlineSwatch) {
      generateCanvas({
        color: currentOutlineColor,
        text: currentOutlineText,
        id: "outline",
        withStroke: true,
        font,
      });
    } else {
      // Clear the outline canvas if no text or color
      const existingCanvas = document.getElementById("outline-canvas");
      const existingWrapper = document.getElementById("outline-canvas-wrapper");
      if (existingCanvas) existingCanvas.remove();
      if (existingWrapper) existingWrapper.remove();
    }
  }

  if (threeD !== null) {
    if (threeDGridColumn !== undefined) {
      threeD.style.gridColumn = threeDGridColumn;
    }
  }

  if (hasCurrentColor) {
    const currentColor = selectSingleElement<HTMLElement>(CURRENT_COLOR_SELECTOR);
    if (currentColor !== null) {
      generateCanvas({
        color: "transparent",
        text: "",
        id: "outline",
        withStroke: true,
      });
    }
  }
}
